const preloader = () => {
  const preloaderNode = document.querySelector('.js-preloader');
  if (!preloaderNode) return;

  class Preloader {
    constructor(el) {
      this.el = el;
      this.durationFadeout = this.el.dataset.durationFadein;
      this.durationFadein = this.el.dataset.durationFadeout;

      if (window.pageYOffset > 0) {
        this.load();
      } else {
        // window.disableBodyScroll();
        this.el.classList.add('is-hidden');
        // setTimeout(() => {
        //   window.enableBodyScroll();
        // }, 5000);
      }
    }

    load() {
      window.disableBodyScroll();

      window.addEventListener('load', () => {
        setTimeout(() => {
          this.hide();
        }, 500);
      })
    }

    hide() {
      window.enableBodyScroll();
      this.el.classList.add('is-ready');

      setTimeout(() => {
        this.el.classList.add('is-hidden');
      }, 1000);

    }
  }

  new Preloader(preloaderNode);
};

export {preloader};
